/**
 * A chat the app has just been handed — created from Home, or branched —
 * kept for the moment between navigating and the chat page mounting, so the
 * page draws it at once instead of fetching what it was just given.
 *
 * Module memory, so a reload finds nothing and fetches. The first message's
 * turn is not handed over here at all: Home starts it in the turn store
 * (`useTurns.ts`) before navigating, which is also why a reload cannot send it
 * twice.
 */

import type { Chat, ChatSummary } from '../api';

const stash = new Map<string, Chat>();

export function stashChat(chat: Chat): void {
  stash.set(chat.id, chat);
}

/** Read without consuming: React may call a state initialiser twice. */
export const peekChat = (id: string): Chat | null => stash.get(id) ?? null;

export function dropChat(id: string): void {
  stash.delete(id);
}

/** The sidebar's view of a chat. */
export const toSummary = (c: Chat): ChatSummary => ({
  id: c.id,
  title: c.title,
  projectId: c.projectId,
  updatedAt: c.updatedAt,
  needsYou: c.needsYou,
  temporary: c.temporary,
  automationId: c.automationId ?? null,
  agent: c.agent ?? null,
  deviceId: c.deviceId ?? null
});
